<script lang="ts">
import MooveTerms from '@/components/pages/register/terms/MooveTerms.vue';
import IndvTerms from '@/components/pages/register/terms/IndvTerms.vue';
import AgreeModalComp from '@/components/common/modal/AgreeModalComp.vue';
import {useTermsAgree} from '@/script/auth/reigsterScript';
import {defineComponent} from 'vue';

export default defineComponent({
  components: {
    MooveTerms,
    IndvTerms,
    AgreeModalComp,
  },
  setup() {
    const {
      terms,
      termsVisible,
      openTerms,
    } = useTermsAgree()

    return {
      terms,
      termsVisible,
      openTerms,
    }
  }
})
</script>

<template>
  <div class="common-footer">
    <div>
      {{ $t('footer.info') }}
    </div>
    <div class="terms-row">
      <strong class="cursor-pointer" @click="openTerms('IndvTerms')">{{ $t('footer.indv')}}</strong>
      <div class="divider"></div>
      <span class="cursor-pointer" @click="openTerms('MooveTerms')">{{ $t('footer.service') }}</span>
    </div>
    <agree-modal-comp
        v-model:visible="termsVisible"
        mode="confirm"
    >
      <template #content>
        <component :is="terms"/>
      </template>
    </agree-modal-comp>
  </div>
</template>

<style scoped lang="scss">
.common-footer {
  color: #4B465C;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  background: var(--bg-home-color);
  white-space: pre-line;
  padding: 100px 20px 110px 20px;
  strong {
    font-weight: 600;
  }
  .terms-row {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    margin-top: 24px;
  }
  .divider {
    width: 1px;
    height: 16px;
    background: #333333;
  }
  .terms-sheet {
    padding: 0 20px;
  }
}
</style>

